// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/section-bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sections */
.oc-section-three {
  background-color: #f7f7f7;
  border-top-right-radius: 2.25rem;
}

.oc-section-three-title {
  font-family: DMSans-Bold;
  font-size: 2.875rem;
  line-height: 3.375rem;
  color: #000;
  padding-left: 6.0625rem;
  margin-bottom: 2.75rem;
}

.oc-section-three-inner {
  background-color: #efefef;

  padding: 6.125rem 5.8125rem 11.5625rem 6.0625rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;
  background-blend-mode: luminosity;
}

@media (max-width: 1080px) {
  .oc-section-three-inner {
    /* Remove padding for mobile devices */
    padding: 0;
    height: 100vh;
    display: flex;
    justify-content: center; /* Horizontally center the child div */
    align-items: center; /* Vertically center the child div */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/sectionThree/SectionThree.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;;EAEzB,gDAAgD;EAChD,yDAA2D;EAC3D,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE;IACE,sCAAsC;IACtC,UAAU;IACV,aAAa;IACb,aAAa;IACb,uBAAuB,EAAE,sCAAsC;IAC/D,mBAAmB,EAAE,oCAAoC;EAC3D;AACF","sourcesContent":["/* Sections */\n.oc-section-three {\n  background-color: #f7f7f7;\n  border-top-right-radius: 2.25rem;\n}\n\n.oc-section-three-title {\n  font-family: DMSans-Bold;\n  font-size: 2.875rem;\n  line-height: 3.375rem;\n  color: #000;\n  padding-left: 6.0625rem;\n  margin-bottom: 2.75rem;\n}\n\n.oc-section-three-inner {\n  background-color: #efefef;\n\n  padding: 6.125rem 5.8125rem 11.5625rem 6.0625rem;\n  background-image: url(\"../../assets/images/section-bg.svg\");\n  background-repeat: no-repeat;\n  background-position: right;\n  background-size: cover;\n  background-blend-mode: luminosity;\n}\n\n@media (max-width: 1080px) {\n  .oc-section-three-inner {\n    /* Remove padding for mobile devices */\n    padding: 0;\n    height: 100vh;\n    display: flex;\n    justify-content: center; /* Horizontally center the child div */\n    align-items: center; /* Vertically center the child div */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
